import { Color } from './color'
import { XColor } from './xcolor'
import { Echo } from './echo'
import { Gensymb } from './gensymb'
import { Graphics } from './graphics'
import { Graphicx } from './graphicx'
import { Hyperref } from './hyperref'
import { Latexsym } from './latexsym'
import { Multicol } from './multicol'
import { Stix } from './stix'
import { Textcomp } from './textcomp'
import { Textgreek } from './textgreek'


export default {
    color: Color,
    xcolor: XColor,
    echo: Echo,
    gensymb: Gensymb,
    graphics: Graphics,
    graphicx: Graphicx,
    hyperref: Hyperref,
    latexsym: Latexsym,
    multicol: Multicol,
    stix: Stix,
    textcomp: Textcomp,
    textgreek: Textgreek,
}